/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import axios from 'axios';
import { CotizadorContext } from '../context';
import useSimulationData from './useSimulationData';
import { getTotalFromSimulation, runSimulation } from '../components/utils/creditSimulation';

const useCarsData = () => {
    const [state, setState] = useContext(CotizadorContext)
    const { simulate } = useSimulationData();

    const getCars = async () => {
        const response = await axios.get('/api/kinto/one_business_cars');
        setState(prevState => ({
            ...prevState,
            available_cars: response?.data
        }))
    }

    const getSelectedCar = () => {
        if (state.selected_car) {
            return state.available_cars.find(car => car.id === state.selected_car);
        }

        return null;
    }

    const setSelectedCar = async selected_car => {
        document.getElementById('cotizador_overlay').style.display = 'block';
        const simulationResult = await runSimulation(selected_car, state.selected_time, state.selected_distance, state.downpayment_percentage);

        if (!simulationResult.success) {
            console.error('[useCarsData] Error en simulación:', simulationResult.error);
        }

        // Si la simulación falla, igual se actualiza el auto y se muestra el error
        setState(prevState => ({
            ...prevState,
            selected_car,
            simulation_results: simulationResult.data,
            simulation_total: getTotalFromSimulation(simulationResult.data),
            ...(simulationResult.success ? {} : { error_notification: simulationResult.error }),
        }));

        document.getElementById('cotizador_overlay').style.display = 'none';
    }

    return {
        cars: state.available_cars,
        getSelectedCar,
        setSelectedCar,
        getCars
    };
}

export default useCarsData;
